export type ModalSearchSelectionMode = "single" | "multi";

export interface ModalSearchSelectionOptions {
    mode?: ModalSearchSelectionMode;
    delimiter?: string;
}

export type ModalSearchSelectionScalar = string | null | undefined;
export type ModalSearchSelectionInput = ModalSearchSelectionScalar | ModalSearchSelectionScalar[];

export class ModalSearchSelectionIO {
    public static parseIdsFromValue(
        value: ModalSearchSelectionInput,
        options: ModalSearchSelectionOptions = {},
    ): string[] {
        const mode = options.mode === "single" ? "single" : "multi";
        const delimiter = String(options.delimiter || ",");

        if (Array.isArray(value)) {
            const ids = value.map((item) => String(item ?? "").trim()).filter(Boolean);
            return mode === "single" ? (ids[0] ? [ids[0]] : []) : ids;
        }

        const raw = String(value ?? "").trim();
        if (!raw) return [];

        const ids = raw
            .split(delimiter)
            .map((item) => String(item ?? "").trim())
            .filter(Boolean);

        return mode === "single" ? (ids[0] ? [ids[0]] : []) : ids;
    }

    public static serializeIds(ids: string[], options: ModalSearchSelectionOptions = {}): string {
        const mode = options.mode === "single" ? "single" : "multi";
        const delimiter = String(options.delimiter || ",");

        const rows = Array.isArray(ids) ? ids : [];
        const normalized = rows.map((item) => String(item ?? "").trim()).filter(Boolean);

        if (mode === "single") {
            return normalized[0] ? String(normalized[0]) : "";
        }

        return normalized.join(delimiter);
    }

    public static firstId(ids: ModalSearchSelectionScalar[] | null | undefined): string {
        const rows = Array.isArray(ids) ? ids : [];
        return String(rows[0] ?? "").trim();
    }
}
